import React, { createContext, useRef, useState } from "react";
import { useClickAway } from "react-use";
import styled from "styled-components";

type Props = {
  children: React.ReactNode;
  alignment: "left" | "right";
};

export const HeaderDropdownContext = createContext<{
  isDropdownOpen?: boolean;
  setIsDropdownOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  isDropdownOpen: undefined,
  setIsDropdownOpen: undefined,
});

export const HeaderDropdown = ({ children, alignment }: Props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  const containerRef = useRef<HTMLDivElement>(null);

  useClickAway(containerRef, () => setIsDropdownOpen(false));

  return (
    <HeaderDropdownContext.Provider
      value={{
        isDropdownOpen,
        setIsDropdownOpen,
      }}
    >
      <Container ref={containerRef} alignment={alignment}>
        {children}
      </Container>
    </HeaderDropdownContext.Provider>
  );
};

const Container = styled("div").withConfig({ shouldForwardProp: (prop) => !["alignment"].includes(prop) })<{
  alignment: Props["alignment"];
}>`
  display: flex;
  position: relative;
  width: 100%;
  justify-self: ${(props) => {
    switch (props.alignment) {
      case "left":
        return "start";
      case "right":
        return "end";
      default:
        return "center";
    }
  }};
`;
